export const THEME = {
  darkMode: {
    header: '#263238',
    card: '#455A64',
    subCard: '#55707c',
    textColor: 'white',
    backgroundColor: '#37474F',
    chipColor: 'secondary',
    buttonStyle: 'contained',
    border: 'none'
  },
  dorkMode: {
    header: 'black',
    card: 'black',
    subCard: 'black',
    textColor: 'white',
    backgroundColor: 'black',
    chipColor: 'secondary',
    buttonStyle: 'outlined',
    border: '2px solid white'
  },
  lightMode: {
    header: '#ECEFF1',
    card: '#ECEFF1',
    subCard: '#DADCDE',
    textColor: '#212121',
    backgroundColor: '#CFD8DC',
    chipColor: 'default',
    buttonStyle: 'contained',
    border: 'none'
  }
}